import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "video-grid" }

import {onMounted} from 'vue';
import PlayerModal from './components/PlayerModal.vue';
import VideoItem from './components/VideoItem.vue';
import {useStore} from './store';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

onMounted(() => {
    store.fetchVideos();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).videos, (video, index) => {
        return (_openBlock(), _createBlock(VideoItem, {
          key: index,
          video: video
        }, null, 8 /* PROPS */, ["video"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    _createVNode(PlayerModal)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})